import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { appEntryService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseSubmitSignApplicationMutationProps = {
	applicationId: string;
	onSuccess?: Function;
	onError?: Function;
};

const useSubmitSignApplicationMutation = ({
	applicationId,
	onSuccess,
	onError,
}: UseSubmitSignApplicationMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		(applicationData: { [key: string]: any }) => {
			return appEntryService.signApp({
				applicationData,
				applicationId,
			});
		},
		{
			onMutate() {
				dispatch(
					uiActions.showSpinnerOverlay(
						true,
						"PDF document is generating for signature",
					),
				);
			},
			onSuccess(resLink) {
				let newWindow = window.open(resLink, "_blank");
				if (newWindow === null || typeof newWindow === "undefined") {
					dispatch(
						uiActions.showErrorNotification({
							title: "Please allow pop-up windows for RISE website to proceed.",
						}),
					);
					onError?.();
				} else {
					newWindow.focus();
					onSuccess?.();
				}
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useSubmitSignApplicationMutation;
